<template>
    <page>
        <div class="shadow-25">
            <v-header :title="$T('reverse flow')" icon="list">
                <template slot="right">
                    <v-button
                        flat
                        rounded
                        dense
                        color="primary"
                        icon="list"
                        :label="$T('go to list')"
                        @click="
              $router.push({
                name: `backoffice.lending-point.detail`,
                params: $route.params.id,
              })
            "
                    >
                    </v-button>
                </template>
            </v-header>
            <card
                title-inverted
                title-color="primary"
                footer-color="white"
                width="100%"
            >
                <form method="post" @submit.prevent="save" class="row gutter-sm">
                    <div class="col-12 row justify-center gutter-x-md">
                        <v-select
                            auto-select
                            :form="inputValue"
                            v-model="inputValue.product_model_id"
                            :options="this.products"
                            :label="$T('Product')"
                            class="col-4"
                            :disable="$route.params.product"
                        />

                        <v-input
                            :form="inputValue"
                            v-model="inputValue.minimum_stock"
                            type="number"
                            :label="$T('Minimum Stock')"
                            class="col-4"
                        />

                        <v-input
                            :form="inputValue"
                            v-model="inputValue.maximum_stock"
                            type="number"
                            :label="$T('Maximum Stock')"
                            class="col-4"
                        />
                    </div>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md">
                        <v-button
                            outline
                            :label="submitLabel"
                            icon="save"
                            color="highlight"
                            class="no-shadow uppercase q-btn-iqos"
                            type="submit"
                        >
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ loadingLabel | capitalize }}
                            </template>
                        </v-button>
                    </div>
                </form>
            </card>
        </div>
    </page>
</template>

<script>
import {QTooltip, QSpinnerPuff} from "quasar-framework";
import Form from "vform";
import axios from "axios";
import {mapGetters} from "vuex";
import {Notify} from 'quasar-framework'

export default {
    middleware: "auth",
    components: {
        QTooltip,
        QSpinnerPuff,
        Form,
    },
    data() {
        return {
            inputValue: {
                id: null,
                product_model_id: null,
                minimum_stock: null,
                maximum_stock: null,
            },
            slug: `lending-point/` + this.$route.params.id + `/reverse-flow`,
            form: {},
            products: [],
        };
    },
    mounted() {
        this.getMockData();
    },

    methods: {
        async getMockData() {
            let urlApi =
                "/api/v1/lending-point/" +
                this.$route.params.id +
                "/reverse-flow/form-mock-data" +
                (this.$route.params.product ? "/" + this.$route.params.product : "");

            await axios.get(urlApi).then((res) => {
                let data = res.data.data;
                this.products = data.products;

                if (data.productReverseFlow) {
                    this.inputValue = data.productReverseFlow;
                }
            });
        },

        async save() {
            this.form = new Form(Object.assign(deepCopy(this.inputValue)));

            //if (this.validateForm()) {
                await this.form
                    .post(`/api/v1/lending-point/` + this.$route.params.id + "/attach")
                    .then(({data}) => {
                        this.$emit("updated");

                        this.$q
                            .dialog({
                                title: this.$T("success"),
                                message: data.success.message,
                                preventClose: true,
                                color: "primary",
                                stackButtons: true,
                                ok: {
                                    label: this.$T("close"),
                                },
                            })
                            .then(() => {
                                this.$router.push({
                                    name: `backoffice.lending-point.detail`,
                                    params: this.$route.params.id,
                                });
                            });
                    })
                    .catch((response) => console.log(response));
            //}
        },

        validateForm() {

            if (this.form.product_model_id === null || this.form.minimum_stock === null || this.form.maximum_stock === null) {
                this.notify(this.$T('error'), this.$T('All fields are required'), [], 'negative')

                return false
            }
            else if (parseInt(this.form.minimum_stock) < 0 || parseInt(this.form.maximum_stock) < 0) {

                this.notify(this.$T('error'), this.$T('Negative numbers are not allowed'), [], 'negative')

                return false
            }
            else if (parseInt(this.form.minimum_stock) >= parseInt(this.form.maximum_stock)) {
                this.notify(this.$T('error'), this.$T("Stock minimum can't be equal or greater than the stock maximum"), [], 'negative')

                return false
            }

            return true
        },

        notify(message, detail, actions = [], type = 'positive') {
            this.$q.notify({
                type,
                position: 'top',
                message,
                detail,
                timeout: 5000,
                actions
            })
        },
    },

    computed: {
        isEditing() {
            return this.$route && this.$route.params.product;
        },

        resourceURL() {
            return (
                `${config.appUrl}/api/lending-point/` +
                this.$route.params.id +
                `/${this.isEditing ? this.$route.params.product : ""}`
            );
        },

        submitLabel() {
            return !this.isEditing ? this.$T("save") : this.$t("update");
        },

        loadingLabel() {
            return !this.isEditing ? this.$T("saving...") : this.$T("updating...");
        },

        successMessage() {
            return getNested("success.message", this.responseData);
        },

        ...mapGetters({
            user: "auth/user",
        }),
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/markets/ES/pages/backoffice/lending-point/form-reverse-flow.vue